
























import Vue from 'vue'
import ShareButton from '~/components/ShareButton.vue'

export default Vue.extend({
  components: {
    ShareButton
  },
  props: {
    urlToShare:
    {
      type: String,
      default: ''
    },
    imageClass:
    {
      type: String,
      default: ''
    },
    imageAlt:
    {
      type: String,
      default: ''
    },
    imageSrc:
    {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showShare: false
    }
  },
  methods: {
    showHideShareControls (show: boolean) {
      this.showShare = show
    }
  }
})
